<template>
  <div class="c-Publicity">
    <el-carousel
      height="50px"
      :autoplay="true"
      indicator-position="none"
      arrow="never"
      :interval="3000"
    >
      <el-carousel-item v-for="item in message" :key="item.key">
        <div class="item" :class="{ actiname: item.key === 0 }">
          <span v-if="item.title" class="title"> {{ item.title }}</span>
          <span v-if="item.value" class="value">
            {{ item.value }}
          </span>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { conversionCategoryName } from '@/helper/index';

export default {
  name: 'Publicity',
  computed: {
    config() {
      return this.$store.state.config;
    },
    storeNewLottery() {
      return this.$store.state.newLottery;
    },
    result() {
      return this.$store.state.result;
    },
    message() {
      const { result, config } = this;

      let message = [{ key: 0, title: config.name }];
      this.storeNewLottery.forEach((item, index) => {
        let label = conversionCategoryName(item.key);
        if (result[item.key]) {
          const chunkSize = 10;
          const newResult = [];
          for (let i = 0; i < result[item.key].length; i += chunkSize) {
            const chunk = result[item.key].slice(i, i + chunkSize);
            newResult.push(chunk);
          }
          newResult.forEach((it, idx) => {
            message.push({
              key: `key_${index}_${idx}`,
              title: `${label}抽奖结果:`,
              value: `${
                  it.map(it => it.name).join('、')
              }`
            });
          })
        }
      });

      return message;
    }
  }
};
</script>
<style lang="scss">
.c-Publicity {
  height: 100%;
  // width: 1000px;
  background-color: rgba(255, 255, 255, 0.1);
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  .el-carousel {
    width: 80vw;
    margin: 0 auto;
  }
  .item {
    text-align: center;
    color: #fff;
    font-size: 16px;
    .title {
      color: #ccc;
    }
    .value {
      margin-left: 10px;
    }
    &.actiname {
      .title {
        color: red;
        font-size: 20px;
      }
    }
  }
}
</style>
